// extracted by mini-css-extract-plugin
module.exports = {"goToOrderButton":"RedirectToOrder_goToOrderButton__SFsqp","text":"RedirectToOrder_text__QIfK0","link":"RedirectToOrder_link__vkBwQ"};